import { get, useDateFormat } from '@vueuse/core';

// Convert blob to base64
export const blobToBase64 = (blob: Blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Convert base64 to blob
export function downloadBase64File(base64: string, filename: string): void {
  const byteCharacters = atob(base64)
  const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0))
  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray])

  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  link.click()

  setTimeout(() => URL.revokeObjectURL(link.href), 1000)
}


/**
 * Returns the hash of a file as a hex string.
 * @param file - The file to hash.
 * @param algorithm - Hash algorithm to use (default: 'SHA-256').
 * @returns A promise with the hex string of the hash.
 */
export const calculateHash = async (file: File, algorithm = 'SHA-256'): Promise<string> => {
  const arrayBuffer = await file.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest(algorithm, arrayBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
}

/**
 * Normalizes a date and time value to the format 'YYYY-MM-DD HH:mm:ss'.
 * @param date - The date and time value to be normalized.
 * @returns Returns the normalized date and time value.
 */
export const normalizeDateTime = (date: any) => {

  if (!date) {
    return null;
  }

  return get(useDateFormat(date, 'YYYY-MM-DD HH:mm:ss'))
}

/**
 * Formats a string by inserting a hyphen every 4 characters.
 * @param value - The string to format.
 * @param chunkSize - The number of characters per chunk (default: 4).
 * @returns A formatted string with hyphens.
 */
export const publicIdFormat = (value: string, chunkSize = 4): string => {
  if (!value) return value

  const chunks = []
  for (let i = 0; i < value.length; i += chunkSize) {
    chunks.push(value.slice(i, i + chunkSize))
  }

  return chunks.join('-')
}

